import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DsdInput } from '@dsd/library-angular';
import { FormulaireCoordonneesBancairesTelephone } from 'src/app/models/formulaire/formulaire-coordonnees-bancaires-telephone.model';
import { TelephoneTypeEnum } from 'src/app/models/telephone-type.enum';

@Component({
  selector: 'app-modification-telephone-bancaire',
  templateUrl: './modification-telephone-bancaire.component.html',
  standalone: false,
})
export class ModificationTelephoneBancaireComponent implements AfterViewInit {
  @Input() formGroup!: FormGroup<FormulaireCoordonneesBancairesTelephone>;
  @Input() name: string;
  @Input() variantTravail: boolean = false;
  @ViewChild('telephone') telephoneInput: DsdInput;

  ngAfterViewInit(): void {
    this.telephoneInput.registerCustomValidate(
      () => this.formGroup.controls.telephone.validator(this.formGroup.controls.telephone) === null,
      { errorKey: 'mask' }
    );
  }

  public get telephoneTypeEnum() {
    return TelephoneTypeEnum;
  }

  public typeTelephone(value: TelephoneTypeEnum): void {
    this.formGroup?.patchValue({
      typeTelephone: value,
      poste: value === TelephoneTypeEnum.CELLULAIRE ? null : this.formGroup.value.poste, // Efface le poste si le type est CELLULAIRE
    });
  }
}
